import CenteredHeader from "../../components/CenteredHeader";
import Footer from "../../components/Footer";
import NotFoundSection from "./components/NotFoundSection";
import "../../styles/inner-page.css";

const NotFoundPage = () => {

    return (
        <body>
            <div className="page-wrapper inner-page-wrapper">
                <CenteredHeader/>
                <NotFoundSection />
                <Footer/>
            </div>
        </body>
    )

}

export default NotFoundPage
